type FussyPoint = {
  curatorPoint: number;
  creatorPoint: number;
  evangelistPoint: number;
  expertPoint: number;
  supporterPoint: number;
};

function totalPoint(point: FussyPoint): number {
  return (
    point.curatorPoint +
    point.creatorPoint +
    point.evangelistPoint +
    point.expertPoint +
    point.supporterPoint
  );
}

export { totalPoint };
